var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sid-select"},[_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Text","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',{attrs:{"label":"Text"}},[_c('b-input',{model:{value:(_vm.element.options.content.previousButton.text),callback:function ($$v) {_vm.$set(_vm.element.options.content.previousButton, "text", $$v)},expression:"element.options.content.previousButton.text"}})],1),_c('sid-font',{attrs:{"sid":`.--${_vm.element.sid}--previews-button`}}),_c('sid-range-slider',{attrs:{"label":"Text Size","sid":`.--${_vm.element.sid}--previews-button`,"rule-name":"font-size"}}),_c('sid-range-slider',{attrs:{"label":"Letter-Spacing","sid":`.--${_vm.element.sid}--previews-button`,"rule-name":"letter-spacing"}}),_c('sid-range-slider',{attrs:{"label":"Line-Height","sid":`.--${_vm.element.sid}--previews-button`,"rule-name":"line-height"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--previews-button`,"rule-name":"color"}})],1)])]},proxy:true},{key:"Hover",fn:function(){return [_c('sid-range-slider',{attrs:{"label":"Text Size","sid":`.--${_vm.element.sid}--previews-button`,"rule-name":"font-size","presudo":":hover"}}),_c('sid-range-slider',{attrs:{"label":"Letter-Spacing","sid":`.--${_vm.element.sid}--previews-button`,"rule-name":"letter-spacing","presudo":":hover"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--previews-button`,"presudo":":hover","rule-name":"color"}})],1)])]},proxy:true}])})],1),_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Icon","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-range-slider',{attrs:{"label":"Text Size","sid":`.--${_vm.element.sid}--previous-button-icon`,"rule-name":"font-size"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--previous-button-icon`,"rule-name":"color"}})],1)])]},proxy:true},{key:"Hover",fn:function(){return [_c('sid-range-slider',{attrs:{"label":"Text Size","sid":`.--${_vm.element.sid}--previous-button-icon`,"rule-name":"font-size","presudo":":hover"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--previous-button-icon`,"rule-name":"color","presudo":":hover"}})],1)])]},proxy:true}])})],1),_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Layout & Style","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-align',{attrs:{"sid":`.--${_vm.element.sid}--container`,"rule-name":"justify-content","label":"Button Alignment"}}),_c('sid-background',{attrs:{"sid":`.--${_vm.element.sid}--previews-button`,"default-color":"#77abff","small":""}})]},proxy:true},{key:"Hover",fn:function(){return [_c('sid-background',{attrs:{"sid":`.--${_vm.element.sid}--previews-button`,"presudo":":hover","small":""}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Border & Radius","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.element.sid}--previews-button`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.element.sid}--previews-button`,"label":"Border Width","rule-name":"border","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--previews-button`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":`.--${_vm.element.sid}--previews-button`,"rule-name":"border","angles":[
            {
              text: 'Top Left',
              value: 'top-left-radius'
            },
            {
              text: 'Top Right',
              value: 'top-right-radius'
            },
            {
              text: 'Bottom Left',
              value: 'bottom-left-radius'
            },
            {
              text: 'Bottom Right',
              value: 'bottom-right-radius'
            }
          ]}})]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.element.sid}--previews-button`,"rule-name":"border-style","searchable":false,"presudo":":hover","options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.element.sid}--previews-button`,"label":"Border Width","rule-name":"border","presudo":":hover","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--previews-button`,"presudo":":hover","rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":`.--${_vm.element.sid}--previews-button`,"rule-name":"border","presudo":":hover","angles":[
            {
              text: '',
              value: 'top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius'
            }
          ]}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Padding & Margins","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.element.sid}--previews-button`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Margin","sid":`.--${_vm.element.sid}--margin`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }